// src/routes/AppContent.tsx

import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { NavBar } from '../components/navigation/navbar';
import ToastContainer from '../components/ui/ToastContainer';
import { AppLoader } from '../components/ui/AppLoader';
import { hideNavBarRoutes } from './routeConfig';
import { AppRoutes } from './AppRoutes';

// Main App Content - layout shell, navbar visibility, and route mounting.
export const AppContent: React.FC = () => {
  const { isAuthenticated, hasCompletedOnboarding, loading } = useUser();
  const location = useLocation();

  if (loading && location.pathname !== '/') {
    return <AppLoader />;
  }

  const shouldShowNavBar = isAuthenticated && hasCompletedOnboarding && !hideNavBarRoutes.includes(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* TODO: Backend integration - Add skip to main content link for accessibility */}
      {shouldShowNavBar && <NavBar />}
      <main className={shouldShowNavBar ? 'pt-16' : ''} role="main">
        <Suspense
          fallback={
            location.pathname === '/'
              ? null
              : <AppLoader />
          }
        >
          <AppRoutes />
        </Suspense>
      </main>
      <ToastContainer />
    </div>
  );
};

export default AppContent;